import React, { useState, useEffect } from 'react'
import { useLocale } from '@merchant-portal/merchant-portal-base'
import DocumentsUI from './DocumentsUI'
import Forms from './forms'

const Documents = () => {
  const [locale] = useLocale()
  const [documents, setDocuments] = useState([])

  useEffect(() => {
    const { country } = locale
    setDocuments(Forms[country])
  }, [locale])

  return <DocumentsUI documents={documents} />
}

export default Documents
